const LauncherLinks = ({ text, list }) => {
  const normalizedData = { text, list };

  return normalizedData;
};

export default LauncherLinks;
